/** Favorite menu pins — draft + save ke localStorage */
const KEY = 'jgi_favorite_menus';

export function useFavoriteMenus() {
  const saved = useState<string[]>('favorite-menus-saved', () => []);
  const draft = useState<string[]>('favorite-menus-draft', () => []);

  const isDirty = computed(
    () => JSON.stringify(draft.value) !== JSON.stringify(saved.value)
  );

  function load() {
    if (!import.meta.client) return;
    try {
      const raw = localStorage.getItem(KEY);
      const list: string[] = raw ? JSON.parse(raw) : [];
      saved.value = Array.isArray(list) ? list.filter(Boolean) : [];
      draft.value = [...saved.value];
    } catch {
      saved.value = [];
      draft.value = [];
    }
  }

  function persist() {
    if (!import.meta.client) return;
    localStorage.setItem(KEY, JSON.stringify(saved.value));
  }

  function isInDraft(to: string) {
    return !!to && draft.value.includes(to);
  }

  function isFavorite(to: string) {
    return !!to && saved.value.includes(to);
  }

  function add(to: string) {
    if (!to || draft.value.includes(to)) return;
    draft.value = [...draft.value, to];
  }

  function remove(to: string) {
    if (!to) return;
    draft.value = draft.value.filter((x) => x !== to);
  }

  function save() {
    saved.value = [...draft.value];
    persist();
  }

  function discard() {
    draft.value = [...saved.value];
  }

  /** Legacy toggle — tetap ada untuk kompatibilitas singkat */
  function toggle(to: string) {
    if (!to) return;
    if (isInDraft(to)) remove(to);
    else add(to);
  }

  return {
    favorites: draft,
    saved,
    draft,
    isDirty,
    load,
    save,
    discard,
    add,
    remove,
    toggle,
    isFavorite,
    isInDraft,
  };
}
